import { useSnackbar } from "notistack";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideNotification } from "store/slices/snackbar/snackbarSlice";
import { StateObject } from "store/index";

const AppWrapper = ({ children }: any) => {
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const { snackbar } = useSelector((store: StateObject) => store)
    const { message, dismissed, variant } = snackbar;

    const handleClose = useCallback(() => {
        dispatch(hideNotification())
    }, [dispatch])

    useEffect(() => {
        if (!dismissed) {
            enqueueSnackbar(message, {
                preventDuplicate: true,
                variant: variant,
                onClose: handleClose
            })
        }
    }, [dispatch, message, enqueueSnackbar, dismissed, handleClose, variant])

    return (
        <>
            {children}
        </>
    )
}

export default AppWrapper